module.exports = __webpack_public_path__ + "static/media/Users1.53728239.svg";